<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="CN ParaOverride-1"><span epub:type="pagebreak" id="pagexi" title="xi"></span></p>
<p class="_toc" id="_idParaDest-4">Contents<a id="_idTextAnchor000"></a></p>
<p class="tocFMEM"><a href="#/PM#_idTextAnchor004"><span class="ital">Introduction</span></a><span class="ital">: Priestess of the Morrigan </span></p>
<p class="tocPT"><a href="#/PM1#_idTextAnchor005">Part 1</a>: The Nature of the Morrigan</p>
<p class="tocCh"><a href="#/PM2#_idTextAnchor006"><span class="med">Chapter 1</span></a><span class="med">:</span> The Morrigan: Who She Is and Who She Isn’t  </p>
<p class="tocCh"><a href="#/PM3#_idTextAnchor007"><span class="med">Chapter 2</span></a><span class="med">:</span> Belly Full of Blood: The Morrigan and War  </p>
<p class="tocCh"><a href="#/PM4#_idTextAnchor008"><span class="med">Chapter 3</span></a><span class="med">:</span> Victory and Healing  </p>
<p class="tocCh"><a href="#/PM5#_idTextAnchor009"><span class="med">Chapter 4</span></a><span class="med">:</span> Not for a Woman’s Backside: Sex and the Morrigan  </p>
<p class="tocCh"><a href="#/PM6#_idTextAnchor010"><span class="med">Chapter 5</span></a><span class="med">:</span> The Price of a Crown: Goddess of Sovereignty  </p>
<p class="tocCh"><a href="#/PM7#_idTextAnchor011"><span class="med">Chapter 6</span></a><span class="med">:</span> Invoking the Peace: <a id="_idTextAnchor001"></a>Battlefield Devotions  </p>
<p class="tocPT"><a href="#/PM8#_idTextAnchor014">Part 2</a>: Vision and Prophecy</p>
<p class="tocCh"><span class="med"><a id="_idTextAnchor002"></a></span><a href="#/PM9#_idTextAnchor015"><span class="med">Chapter 7</span></a><span class="med">:</span> Becoming the Vessel: Visionary Work and the Morrigan  </p>
<p class="tocCh"><a href="#/PM10#_idTextAnchor019"><span class="med">Chapter 8</span></a><span class="med">:</span> The Morrigan’s Wolves: A Vision Regarding Community </p>
<p class="tocCh"><a href="#/PM11#_idTextAnchor020"><span class="med">Chapter 9</span></a><span class="med">:</span> Poisonous Hearts: A Vision of Serpents  </p>
<p class="tocCh"><a href="#/PM12#_idTextAnchor021"><span class="med">Chapter 10</span></a><span class="med">:</span> UPG and the Morrigan  </p>
<p class="tocPT"><a id="_idTextAnchor003"></a><a href="#/PM13#_idTextAnchor022">Part 3</a>: Devotions and Oaths</p>
<p class="tocCh"><a href="#/PM14#_idTextAnchor023"><span class="med">Chapter 11</span></a><span class="med">:</span> Initiations  </p>
<p class="tocCh"><a href="#/PM15#_idTextAnchor024"><span class="med">Chapter 12</span></a><span class="med">:</span> Devotional Work  </p>
<p class="tocCh"><a href="#/PM16#_idTextAnchor026"><span class="med">Chapter 13</span></a><span class="med">:</span> The Halidom of Macha: Oaths and Vows  </p>
<p class="tocPT"><span epub:type="pagebreak" id="pagexii" title="xii"><a href="#/PM17#_idTextAnchor028">Part 4</a>: Sorcery and Ritual Craft</span></p>
<p class="tocCh"><a href="#/PM18#_idTextAnchor029"><span class="med">Chapter 14</span></a><span class="med">:</span> She Sung Spells of Power:   Curse Work and the Morrigan </p>
<p class="tocCh"><a href="#/PM19#_idTextAnchor030"><span class="med">Chapter 15</span></a><span class="med">:</span> Ritual Dynamics  </p>
<p class="tocCh"><a href="#/PM20#_idTextAnchor034"><span class="med">Chapter 16</span></a><span class="med">:</span> Group Rituals  </p>
<p class="tocFMEM"><a href="#/PM21#_idTextAnchor036"><span class="ital">Conclusion</span></a> </p>
<p class="tocFMEM"><a href="#/PM22#_idTextAnchor039"><span class="ital">Appendix:</span></a> <span class="ital">Irish Myths and Resources</span> </p>
<p class="tocFMEM"><a href="#/PM23#_idTextAnchor040"><span class="ital">Bibliography</span></a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?240d0976